import React from 'react';
import colors from '../../../theme/colors';
import TopmenuButton from './TopmenuButton';

export const ScheduleIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
      <path d="M2 11.3334H8.66667" stroke={colors.secondary} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6.66663 4.66663H13.3333" stroke={colors.secondary} strokeWidth="1.5" strokeLinecap="round" />
      <path stroke={colors.secondary} strokeWidth="1.5" d="M9.4166 11.3333a1.9167 1.9167 0 1 0 3.8333 0a1.9167 1.9167 0 1 0 -3.8333 0" />
      <path d="M5.91671 4.66667C5.91671 5.72521 5.05859 6.58333 4.00004 6.58333C2.94149 6.58333 2.08337 5.72521 2.08337 4.66667C2.08337 3.60812 2.94149 2.75 4.00004 2.75C5.05859 2.75 5.91671 3.60812 5.91671 4.66667Z" stroke={colors.secondary} strokeWidth="1.5" />
  </svg>
);

const ButtonSchedule = (props: any) => {
  const { className, isLightMode } = props;
  return (
    <TopmenuButton {...props} isLightMode={isLightMode} className={`topmenu-button ${className}`} type="button">
      <ScheduleIcon />
    </TopmenuButton>
  );
};

export default ButtonSchedule;
